

// import { NavLink } from 'react-router-dom';
// import {
//   FiChevronLeft,
//   FiChevronRight,
// } from 'react-icons/fi';
// import {
//   FaTh,
//   FaFileInvoice,
//   FaBoxOpen,
//   FaBell,
//   FaSignOutAlt,
//   FaClipboardList,
//   FaFileAlt,
// } from 'react-icons/fa';
// import styles from '../../assets/scss/Sidebar.module.scss';
// import { getUserInfo } from '../../utils/user.util';

// const Sidebar = ({ isOpen, toggleSidebar }) => {

//     const user = getUserInfo();

//     console.log(`User Info:`, user);

//   return (
//     <div className={`${styles.sidebar} ${!isOpen ? styles.closed : ''}`}>
//       <div className={styles.toggleBtn} onClick={toggleSidebar}>
//         {isOpen ? <FiChevronLeft /> : <FiChevronRight />}
//       </div>

//       <nav>
//         <NavLink
//           to="/dashboard"
//           end
//           className={({ isActive }) =>
//             `${styles.link} ${isActive ? styles.active : ''}`
//           }
//         >
//           <FaTh className={styles.icon} />
//           <span className={styles.text}>Dashboard</span>
//         </NavLink>


//         <NavLink
//           to="/dashboard/inventory"
//           className={({ isActive }) =>
//             `${styles.link} ${isActive ? styles.active : ''}`
//           }
//         >
//           <FaClipboardList className={styles.icon} />
//           <span className={styles.text}>Inventory Management</span>
//         </NavLink>

//         <NavLink
//           to="/dashboard/billing"
//           className={({ isActive }) =>
//             `${styles.link} ${isActive ? styles.active : ''}`
//           }
//         >
//           <FaFileAlt className={styles.icon} />
//           <span className={styles.text}>Billing</span>
//         </NavLink>

//         <NavLink
//           to="/dashboard/Ordertable"
//           className={({ isActive }) =>
//             `${styles.link} ${isActive ? styles.active : ''}`
//           }
//         >
//           <FaBoxOpen className={styles.icon} />
//           <span className={styles.text}>Orders</span>
//         </NavLink>

//         <NavLink
//           to="/dashboard/Invoicetable"
//           className={({ isActive }) =>
//             `${styles.link} ${isActive ? styles.active : ''}`
//           }
//         >
//           <FaFileInvoice className={styles.icon} />
//           <span className={styles.text}>Invoice</span>
//         </NavLink>

//         <NavLink
//           to="/dashboard/reports"
//           className={({ isActive }) =>
//             `${styles.link} ${isActive ? styles.active : ''}`
//           }
//         >
//           <FaClipboardList className={styles.icon} />
//           <span className={styles.text}>Reports</span>
//         </NavLink>

//         <NavLink
//           to="/dashboard/notifications"
//           className={({ isActive }) =>
//             `${styles.link} ${isActive ? styles.active : ''}`
//           }
//         >
//           <FaBell className={styles.icon} />
//           <span className={styles.text}>Notifications</span>
//         </NavLink>

//         <NavLink
//           to="/logout"
//           className={({ isActive }) =>
//             `${styles.link} ${isActive ? styles.active : ''}`
//           }
//         >
//           <FaSignOutAlt className={styles.icon} />
//           <span className={styles.text}>Logout</span>
//         </NavLink>
//       </nav>
//     </div>
//   );
// };

// export default Sidebar;







// import { NavLink } from 'react-router-dom';
// import {
//   FiChevronLeft,
//   FiChevronRight,
// } from 'react-icons/fi';
// import {
//   FaTh,
//   FaFileInvoice,
//   FaBoxOpen,
//   FaBell,
//   FaSignOutAlt,
//   FaClipboardList,
//   FaFileAlt,
// } from 'react-icons/fa';
// import styles from '../../assets/scss/Sidebar.module.scss';
// import { getUserInfo } from '../../utils/user.util';

// const Sidebar = ({ isOpen, toggleSidebar }) => {
//   const user = getUserInfo();

//   const functionalitySet = new Set();

//   user?.roles?.forEach(role => {
//     role?.permissions?.forEach(permission => {
//       if (permission?.isActive && permission?.functionality) {
//         functionalitySet.add(permission.functionality);
//       }
//     });
//   });

//   functionalitySet.add('notification');
//   functionalitySet.add('logout');

//   const functionalities = Array.from(functionalitySet);

//   const menuItems = [
//     {
//       to: '/dashboard',
//       label: 'Dashboard',
//       icon: <FaTh />,
//       key: 'dashboard',
//       end: true, // ✅ only dashboard should use 'end'
//     },
//     {
//       to: '/dashboard/InventoryTable',
//       label: 'Inventory Management',
//       icon: <FaClipboardList />,
//       key: 'inventory',
//     },
//     {
//       to: '/dashboard/billing',
//       label: 'Billing',
//       icon: <FaFileAlt />,
//       key: 'billing',
//     },
//     {
//       to: '/dashboard/Ordertable',
//       label: 'Orders',
//       icon: <FaBoxOpen />,
//       key: 'orders',
//     },
//     {
//       to: '/dashboard/Invoicetable',
//       label: 'Invoice',
//       icon: <FaFileInvoice />,
//       key: 'invoice',
//     },
//     {
//       to: '/dashboard/reports',
//       label: 'Reports',
//       icon: <FaClipboardList />,
//       key: 'reports',
//     },
//     {
//       to: '/dashboard/notifications',
//       label: 'Notifications',
//       icon: <FaBell />,
//       key: 'notification',
//     },
//     {
//       to: '/logout',
//       label: 'Logout',
//       icon: <FaSignOutAlt />,
//       key: 'logout',
//     },
//   ];

//   return (
//     <div className={`${styles.sidebar} ${!isOpen ? styles.closed : ''}`}>
//       <div className={styles.toggleBtn} onClick={toggleSidebar}>
//         {isOpen ? <FiChevronLeft /> : <FiChevronRight />}
//       </div>

//       <nav>
//         {menuItems.map(({ to, label, icon, key, end }) =>
//           functionalities.includes(key) && (
//             <NavLink
//               key={key}
//               to={to}
//               end={end} // ✅ only passed for dashboard
//               className={({ isActive }) =>
//                 `${styles.link} ${isActive ? styles.active : ''}`
//               }
//             >
//               {icon}
//               <span className={styles.text}>{label}</span>
//             </NavLink>
//           )
//         )}
//       </nav>
//     </div>
//   );
// };

// export default Sidebar;

import { useState, useEffect } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import {
  FiChevronLeft,
  FiChevronRight,
} from 'react-icons/fi';
import {
  FaTh,
  FaFileInvoice,
  FaBoxOpen,
  FaBell,
  FaSignOutAlt,
  FaClipboardList,
  FaFileAlt,
  FaFolderOpen,
  FaClipboard,
  FaMoneyBillAlt,
  FaCog,
  FaChevronDown,
  FaChevronUp,
  FaQuestionCircle,
  FaEnvelope,
  FaCrown,
  FaListAlt,
  FaUser,
  FaHeadset,
  FaUserTie,
  FaKey,
  FaUsers,
  FaTags,
  FaPaperPlane,
  FaTruck,
  FaPrint,
  FaImage,
  FaWeightHanging,
  FaBuilding,
  FaCreditCard,
  FaDownload,
  FaTools,
} from 'react-icons/fa';
import styles from '../../assets/scss/Sidebar.module.scss';
import { getUserInfo } from '../../utils/user.util';
import DeleteConfirmModalLogout from '../Common/DeleteConfirmModalLogout';
import { adminApi, useLogoutUserMutation } from '../../slices/admin/admin';
import { toast } from 'react-toastify';
import { useDispatch } from 'react-redux';

const Sidebar = ({ isOpen, toggleSidebar }) => {
  const user = getUserInfo();
  const navigate = useNavigate();
  const [logoutModalOpen, setLogoutModalOpen] = useState(false);
  const [isSettingsOpen, setIsSettingsOpen] = useState(false);
  const [isSiteMaintenanceOpen, setIsSiteMaintenanceOpen] = useState(false);
  const [logoutUser] = useLogoutUserMutation();

  const dispatch = useDispatch();

  const functionalitySet = new Set();

  user?.roles?.forEach(role => {
    role?.permissions?.forEach(permission => {
      if (permission?.isActive && permission?.functionality) {
        functionalitySet.add(permission.functionality);
      }
    });
  });

  functionalitySet.add('notification');
  functionalitySet.add('logout');

  const functionalities = Array.from(functionalitySet);

  const userType = user?.type?.toLowerCase() || '';
  const isMyBillsUser = userType.includes('farmer') || userType.includes('retailowner') || userType.includes('customer');
  const billingLabel = isMyBillsUser ? 'My Bill' : 'Sell & Pay';
  const invoiceLabel = userType.includes('farmer') ? 'Sales Invoice' : 'Purchase Invoice';

  const menuItemsTop = [
    {
      to: '/dashboard',
      label: 'Dashboard',
      icon: <FaTh className={styles.icon} />,
      key: 'dashboard',
      end: true,
    },
    {
      to: '/dashboard/billing',
      label: billingLabel,
      icon: <FaFileAlt className={styles.icon} />,
      key: 'billing',
    },
    {
      to: '/dashboard/InventoryTable',
      label: 'Inventory & Buy',
      icon: <FaClipboardList className={styles.icon} />,
      key: 'inventory',
    },
    {
      to: '/dashboard/Ordertable',
      label: 'Order',
      icon: <FaBoxOpen className={styles.icon} />,
      key: 'orders',
    },
    {
      to: '/dashboard/Invoicetable',
      label: invoiceLabel,
      icon: <FaFileInvoice className={styles.icon} />,
      key: 'invoice',
    },
    {
      to: '/dashboard/ExpenseTable',
      label: 'Expense',
      icon: <FaMoneyBillAlt className={styles.icon} />,
      key: 'ledger',
    },
    {
      to: '/dashboard/Ledger',
      label: 'Ledger',
      icon: <FaFolderOpen className={styles.icon} />,
      key: 'ledger',
    },
    {
      to: '/dashboard/Reports',
      label: 'Reports',
      icon: <FaClipboard className={styles.icon} />,
      key: 'reports',
    },
  ];

  const getSettingsItems = () => {
    let baseSettings = [];

    if (userType === 'farmer') {
      baseSettings = [
        { to: '/dashboard/OrganizationSettings', label: 'Organization Detail', icon: <FaBuilding className={styles.icon} />, key: 'settings' },
        { to: '/dashboard/PaymentSettings', label: 'Payment Information', icon: <FaCreditCard className={styles.icon} />, key: 'paymentSettings' },
      ];
    } else if (userType === 'retailowner' || userType === 'customer') {
      baseSettings = [
        { to: '/dashboard/OrganizationSettings', label: 'Organization Detail', icon: <FaBuilding className={styles.icon} />, key: 'settings' },
        { to: '/dashboard/PaymentSettings', label: 'Payment Information', icon: <FaCreditCard className={styles.icon} />, key: 'paymentSettings' },
        { to: '/dashboard/Users', label: 'Employee', icon: <FaUser className={styles.icon} />, key: 'usercontroll' },
      ];
    } else if (userType === 'wholesaleowner') {
      baseSettings = [
        { to: '/dashboard/OrganizationSettings', label: 'Organization Detail', icon: <FaBuilding className={styles.icon} />, key: 'settings' },
        { to: '/dashboard/PaymentSettings', label: 'Payment Information', icon: <FaCreditCard className={styles.icon} />, key: 'paymentSettings' },
        { to: '/dashboard/Users', label: 'Employee', icon: <FaUser className={styles.icon} />, key: 'usercontroll' },
        { to: '/dashboard/ItemCategories', label: 'Item Categories', icon: <FaTags className={styles.icon} />, key: 'categories' },
        { to: '/dashboard/TransportHandlers', label: 'Transport & Handlers', icon: <FaTruck className={styles.icon} />, key: 'transportHandlers' },
        { to: '/dashboard/ThermalPrintSettings', label: 'Thermal Print Settings', icon: <FaPrint className={styles.icon} />, key: 'settings' },
        { to: '/dashboard/BannerSettings', label: 'Banner Settings', icon: <FaImage className={styles.icon} />, key: 'settings' },
        { to: '/dashboard/RS232Settings', label: 'RS-232 Weight Machine Setting', icon: <FaWeightHanging className={styles.icon} />, key: 'settings' },
      ];
    } else if (userType === 'employee' || userType === 'logistic') {
      return []; // Return empty array so organization settings category completely hides
    } else {
      // Default / SuperAdmin fallback for all items
      baseSettings = [
        { to: '/dashboard/OrganizationSettings', label: 'Organization Detail', icon: <FaBuilding className={styles.icon} />, key: 'settings' },
        { to: '/dashboard/PaymentSettings', label: 'Payment Information', icon: <FaCreditCard className={styles.icon} />, key: 'paymentSettings' },
        { to: '/dashboard/Users', label: 'Employee', icon: <FaUser className={styles.icon} />, key: 'usercontroll' },
        { to: '/dashboard/ItemCategories', label: 'Item Categories', icon: <FaTags className={styles.icon} />, key: 'categories' },
        { to: '/dashboard/TransportHandlers', label: 'Transport & Handlers', icon: <FaTruck className={styles.icon} />, key: 'transportHandlers' },
        { to: '/dashboard/ThermalPrintSettings', label: 'Thermal Print Settings', icon: <FaPrint className={styles.icon} />, key: 'settings' },
        { to: '/dashboard/BannerSettings', label: 'Banner Settings', icon: <FaImage className={styles.icon} />, key: 'settings' },
        { to: '/dashboard/RS232Settings', label: 'RS-232 Weight Machine Setting', icon: <FaWeightHanging className={styles.icon} />, key: 'settings' },
      ];
    }

    // Still filter by functionalities available for that role if needed
    return baseSettings.filter(item => functionalities.includes(item.key) || item.key === 'settings' || item.key === 'categories');
  };

  const getSiteMaintenanceItems = () => {
    // All users — show only items they have permission for
    // logistic/employee have no site maintenance permissions, so they'll get empty array naturally
    const maintenanceItems = [
      { to: '/dashboard/UserQuery', label: 'Enquiry', icon: <FaHeadset className={styles.icon} />, key: 'landingPageEnquiry' },
      { to: '/dashboard/DownloadHistory', label: 'Download History', icon: <FaDownload className={styles.icon} />, key: 'downloadHistory' },
      { to: '/dashboard/SubscriptionAdmin', label: 'Subscription Maintenance', icon: <FaCrown className={styles.icon} />, key: 'subscriptionAdmin' },
      { to: '/dashboard/Plans', label: 'Plan Setup', icon: <FaListAlt className={styles.icon} />, key: 'plan' },
      { to: '/dashboard/UserType', label: 'User Type', icon: <FaUsers className={styles.icon} />, key: 'usertype' },
      { to: '/dashboard/Role', label: 'Role', icon: <FaUserTie className={styles.icon} />, key: 'role' },
      { to: '/dashboard/Permissions', label: 'Permission', icon: <FaKey className={styles.icon} />, key: 'permissions' },
    ];

    return maintenanceItems.filter(item => functionalities.includes(item.key));
  };

  const settingsItems = getSettingsItems();
  const siteMaintenanceItems = getSiteMaintenanceItems();

  const menuItemsBottom = [
    {
      to: '/dashboard/Notifications',
      label: 'Notifications',
      icon: <FaBell className={styles.icon} />,
      key: 'notification',
    },
    {
      to: '/dashboard/HelpCenterAdmin',
      label: 'Help Center',
      icon: <FaQuestionCircle className={styles.icon} />,
      key: 'helpcenteradmin',
    },
    {
      to: '/dashboard/HelpCenter',
      label: 'Help Center',
      icon: <FaQuestionCircle className={styles.icon} />,
      key: 'helpcenteruser',
    },
    {
      to: '/logout',
      label: 'Logout',
      icon: <FaSignOutAlt className={styles.icon} />,
      key: 'logout',
    },
  ];

  useEffect(() => {
    if (!isOpen) {
      setIsSettingsOpen(false);
      setIsSiteMaintenanceOpen(false);
    }
  }, [isOpen]);



  const handleLogout = async () => {
    try {
      const data = await logoutUser().unwrap();

      localStorage.clear();
      sessionStorage.clear();

      dispatch(adminApi.util.resetApiState());

      toast.success(data?.message || 'Logout successful');
      navigate('/login');
    } catch (err) {
      toast.error(err?.data?.message || 'Logout failed');
      console.error('Logout error:', err);
    } finally {
      setLogoutModalOpen(false);
    }
  };


  return (
    <>
      <div className={`${styles.sidebar} ${!isOpen ? styles.closed : ''} sidebar-container`}>
        <div className={styles.toggleBtn} onClick={toggleSidebar}>
          {isOpen ? <FiChevronLeft /> : <FiChevronRight />}
        </div>

        <nav>
          {menuItemsTop.map(({ to, label, icon, key, end }) =>
            functionalities.includes(key) && (
              <NavLink
                key={key}
                to={to}
                end={end}
                className={({ isActive }) =>
                  `${styles.link} ${isActive ? styles.active : ''}`
                }
              >
                {icon}
                <span className={styles.text}>{label}</span>
                {!isOpen && <span className={styles.tooltip}>{label}</span>}
              </NavLink>
            )
          )}

          {settingsItems.length > 0 && (
            <div className={styles.settingsContainer}>
              <div
                className={styles.settingsToggle}
                onClick={() => {
                  if (!isOpen) {
                    toggleSidebar();
                    setIsSettingsOpen(true);
                  } else {
                    setIsSettingsOpen(!isSettingsOpen);
                  }
                }}
              >
                <div className={styles.leftPart}>
                  <FaCog className={styles.icon} />
                  <span className={styles.text}>Org Settings</span>
                </div>
                {isOpen && (
                  <span className={`${styles.chevron} ${isSettingsOpen ? styles.chevronOpen : ''}`}>
                    <FaChevronDown />
                  </span>
                )}
                {!isOpen && <h3 className={styles.tooltip}>Org Settings</h3>}
              </div>

              <div className={`${styles.submenu} ${isSettingsOpen && isOpen ? styles.submenuOpen : ''}`}>
                {settingsItems.map(item => (
                  <NavLink
                    key={item.key}
                    to={item.to}
                    className={({ isActive }) =>
                      `${styles.link} ${isActive ? styles.active : ''}`
                    }
                  >
                    <span className={styles.icon}>{item.icon}</span>
                    <span className={styles.text}>{item.label}</span>
                  </NavLink>
                ))}
              </div>
            </div>
          )}

          {siteMaintenanceItems.length > 0 && (
            <div className={styles.settingsContainer}>
              <div
                className={styles.settingsToggle}
                onClick={() => {
                  if (!isOpen) {
                    toggleSidebar();
                    setIsSiteMaintenanceOpen(true);
                  } else {
                    setIsSiteMaintenanceOpen(!isSiteMaintenanceOpen);
                  }
                }}
              >
                <div className={styles.leftPart}>
                  <FaTools className={styles.icon} />
                  <span className={styles.text}>Site Maintainance</span>
                </div>
                {isOpen && (
                  <span className={`${styles.chevron} ${isSiteMaintenanceOpen ? styles.chevronOpen : ''}`}>
                    <FaChevronDown />
                  </span>
                )}
                {!isOpen && <h3 className={styles.tooltip}>Site Maintainance</h3>}
              </div>

              <div className={`${styles.submenu} ${isSiteMaintenanceOpen && isOpen ? styles.submenuOpen : ''}`}>
                {siteMaintenanceItems.map(item => (
                  <NavLink
                    key={item.key + item.to}
                    to={item.to}
                    className={({ isActive }) =>
                      `${styles.link} ${isActive ? styles.active : ''}`
                    }
                  >
                    <span className={styles.icon}>{item.icon}</span>
                    <span className={styles.text}>{item.label}</span>
                  </NavLink>
                ))}
              </div>
            </div>
          )}

          {menuItemsBottom.map(({ to, label, icon, key, end }) =>
            functionalities.includes(key) && key !== 'logout' ? (
              <NavLink
                key={key}
                to={to}
                end={end}
                className={({ isActive }) =>
                  `${styles.link} ${isActive ? styles.active : ''}`
                }
              >
                {icon}
                <span className={styles.text}>{label}</span>
                {!isOpen && <span className={styles.tooltip}>{label}</span>}
              </NavLink>
            ) : key === 'logout' ? (
              <div
                key="logout"
                className={styles.link}
                onClick={() => setLogoutModalOpen(true)}
              >
                {icon}
                <span className={styles.text}>{label}</span>
                {!isOpen && <span className={styles.tooltip}>{label}</span>}
              </div>
            ) : null
          )}
        </nav>

      </div>

      <DeleteConfirmModalLogout
        isOpen={logoutModalOpen}
        onConfirm={handleLogout}
        onCancel={() => setLogoutModalOpen(false)}
        title="Are You Sure?"
        heading="Logout Confirmation"
        content="You want to logout from your account? You will need to log in again to access the system."
      />

    </>
  );
};

export default Sidebar;
